// In CustomLoading.tsx
function CustomLoading({ size = "1.5rem", color = "#fff" }) {
  return (
    <div
      className={`border-4 border-[${color}] border-t-transparent rounded-full animate-spin mx-auto text-center flex items-center justify-center`}
      style={{
        width: size,
        height: size,
      }}
    />
  );
}

export default CustomLoading;
